const lang = {
  sign_up: 'Registrarse',
  manage_your_company_with: 'Gestiona tu empresa con',
  all_in_one_tool: 'Herramienta todo en uno',
  run_and_scale_your_erp_crm_apps: 'Ejecuta y escala tus aplicaciones ERP y CRM',
  easily_add_and_manage_your_services: 'Agrega y gestiona fácilmente tus servicios',
  it_brings_together_your_invoice_clients_and_leads:
    'Reúne tus facturas, clientes y prospectos',
  select_language: 'Seleccionar idioma',
  register: 'Registrar',
  or: 'O',
  already_have_account_login: '¿Ya tienes una cuenta? Inicia sesión',
  name: 'Nombre',
  email: 'Correo electrónico',
  password: 'Contraseña',
  country: 'País',
  afghanistan: 'Afganistán',
  albania: 'Albania',
  algeria: 'Argelia',
  andorra: 'Andorra',
  angola: 'Angola',
  anguilla: 'Anguila',
  argentina: 'Argentina',
  armenia: 'Armenia',
  aruba: 'Aruba',
  australia: 'Australia',
  austria: 'Austria',
  azerbaijan: 'Azerbaiyán',
  bahamas: 'Bahamas',
  bahrain: 'Baréin',
  bangladesh: 'Bangladés',
  barbados: 'Barbados',
  belarus: 'Bielorrusia',
  belgium: 'Bélgica',
  belize: 'Belice',
  benin: 'Benín',
  bermuda: 'Bermudas',
  bhutan: 'Bután',
  bolivia: 'Bolivia',
  bosnia_and_herzegovina: 'Bosnia y Herzegovina',
  botswana: 'Botsuana',
  brazil: 'Brasil',
  brunei_darussalam: 'Brunéi Darussalam',
  bulgaria: 'Bulgaria',
  burkina_faso: 'Burkina Faso',
  burundi: 'Burundi',
  cabo_verde: 'Cabo Verde',
  cambodia: 'Camboya',
  cameroon: 'Camerún',
  canada: 'Canadá',
  central_african_republic: 'República Centroafricana',
  chad: 'Chad',
  chile: 'Chile',
  china: 'China',
  colombia: 'Colombia',
  comoros: 'Comoras',
  congo: 'Congo',
  costa_rica: 'Costa Rica',
  croatia: 'Croacia',
  cuba: 'Cuba',
  cyprus: 'Chipre',
  czechia: 'Chequia',
  cote_d_ivoire: 'Costa de Marfil',
  denmark: 'Dinamarca',
  djibouti: 'Yibuti',
  dominica: 'Dominica',
  dominican_republic: 'República Dominicana',
  ecuador: 'Ecuador',
  egypt: 'Egipto',
  el_salvador: 'El Salvador',
  eritrea: 'Eritrea',
  estonia: 'Estonia',
  eswatini: 'Esuatini',
  ethiopia: 'Etiopía',
  fiji: 'Fiyi',
  finland: 'Finlandia',
  france: 'Francia',
  gabon: 'Gabón',
  gambia: 'Gambia',
  georgia: 'Georgia',
  germany: 'Alemania',
  ghana: 'Ghana',
  gibraltar: 'Gibraltar',
  greece: 'Grecia',
  greenland: 'Groenlandia',
  guadeloupe: 'Guadalupe',
  guam: 'Guam',
  guatemala: 'Guatemala',
  guernsey: 'Guernesey',
  guinea: 'Guinea',
  guinea_bissau: 'Guinea-Bisáu',
  guyana: 'Guyana',
  haiti: 'Haití',
  honduras: 'Honduras',
  hong_kong: 'Hong Kong',
  hungary: 'Hungría',
  iceland: 'Islandia',
  india: 'India',
  indonesia: 'Indonesia',
  iran: 'Irán',
  iraq: 'Irak',
  ireland: 'Irlanda',
  israel: 'Israel',
  italy: 'Italia',
  jamaica: 'Jamaica',
  japan: 'Japón',
  jordan: 'Jordania',
  kazakhstan: 'Kazajistán',
  kenya: 'Kenia',
  korea: 'Corea',
  kuwait: 'Kuwait',
  kyrgyzstan: 'Kirguistán',
  latvia: 'Letonia',
  lebanon: 'Líbano',
  lesotho: 'Lesoto',
  liberia: 'Liberia',
  libya: 'Libia',
  liechtenstein: 'Liechtenstein',
  lithuania: 'Lituania',
  luxembourg: 'Luxemburgo',
  madagascar: 'Madagascar',
  malawi: 'Malaui',
  malaysia: 'Malasia',
  maldives: 'Maldivas',
  mali: 'Malí',
  malta: 'Malta',
  martinique: 'Martinica',
  mauritania: 'Mauritania',
  mauritius: 'Mauricio',
  mexico: 'México',
  moldova: 'Moldavia',
  monaco: 'Mónaco',
  mongolia: 'Mongolia',
  montenegro: 'Montenegro',
  montserrat: 'Montserrat',
  morocco: 'Marruecos',
  mozambique: 'Mozambique',
  myanmar: 'Myanmar',
  namibia: 'Namibia',
  nepal: 'Nepal',
  netherlands: 'Países Bajos',
  new_caledonia: 'Nueva Caledonia',
  new_zealand: 'Nueva Zelanda',
  nicaragua: 'Nicaragua',
  niger: 'Níger',
  nigeria: 'Nigeria',
  norway: 'Noruega',
  oman: 'Omán',
  pakistan: 'Pakistán',
  palestine: 'Palestina',
  panama: 'Panamá',
  papua_new_guinea: 'Papúa Nueva Guinea',
  paraguay: 'Paraguay',
  peru: 'Perú',
  philippines: 'Filipinas',
  poland: 'Polonia',
  portugal: 'Portugal',
  puerto_rico: 'Puerto Rico',
  qatar: 'Catar',
  macedonia: 'Macedonia',
  romania: 'Rumania',
  russia: 'Rusia',
  rwanda: 'Ruanda',
  r_union: 'Reunión',
  saudi_arabia: 'Arabia Saudita',
  senegal: 'Senegal',
  serbia: 'Serbia',
  singapore: 'Singapur',
  slovakia: 'Eslovaquia',
  slovenia: 'Eslovenia',
  somalia: 'Somalia',
  south_africa: 'Sudáfrica',
  south_sudan: 'Sudán del Sur',
  spain: 'España',
  sri_lanka: 'Sri Lanka',
  sudan: 'Sudán',
  suriname: 'Surinam',
  sweden: 'Suecia',
  switzerland: 'Suiza',
  syria: 'Siria',
  taiwan: 'Taiwán',
  tajikistan: 'Tayikistán',
  tanzania: 'Tanzania',
  thailand: 'Tailandia',
  timor_leste: 'Timor Oriental',
  togo: 'Togo',
  tonga: 'Tonga',
  tunisia: 'Túnez',
  turkey: 'Turquía',
  turkmenistan: 'Turkmenistán',
  uganda: 'Uganda',
  ukraine: 'Ucrania',
  united_arab_emirates: 'Emiratos Árabes Unidos',
  united_kingdom: 'Reino Unido',
  united_states: 'Estados Unidos',
  uruguay: 'Uruguay',
  uzbekistan: 'Uzbekistán',
  venezuela: 'Venezuela',
  vietnam: 'Vietnam',
  yemen: 'Yemen',
  zambia: 'Zambia',
  zimbabwe: 'Zimbabue',
  verify_your_account: 'Verifica tu cuenta',
  check_your_email_address_to_verify_your_account:
    'Revisa tu dirección de correo electrónico para verificar tu cuenta',
  complete_verification_by_providing_the_code_that_you_received_by_email:
    'Completa la verificación proporcionando el código que recibiste por correo electrónico',
  verify_now: 'Verificar ahora',
  dashboard: 'Inicio',
  customer: 'Cliente',
  people: 'Personas',
  company: 'Empresa',
  lead: 'Prospecto',
  offer: 'Oferta',
  invoice: 'Factura',
  quote: 'Cotización',
  payment: 'Pago',
  product: 'Producto',
  product_category: 'Categoría de producto',
  expense: 'Gasto',
  expenses_category: 'Categoría de gastos',
  settings: 'Configuración',
  admin: 'Administrador',
  currency: 'Moneda',
  payment_mode: 'Modo de pago',
  taxes: 'Impuestos',
  about: 'Acerca de',
  profile_settings: 'Configuración del perfil',
  app_settings: 'Configuración de la aplicación',
  logout: 'Cerrar sesión',
  number: 'Número',
  client: 'Cliente',
  clients: 'Clientes',
  employee: 'Equipo',
  superadmin: 'Superadmin',
  total: 'Total',
  status: 'Estado',
  invoices_preview: 'Vista previa de facturas',
  quotes_preview: 'Vista previa de cotizaciones',
  offers_preview: 'Vista previa de ofertas',
  payments_preview: 'Vista previa de pagos',
  this_month: 'Este mes',
  unpaid: 'No pagado',
  not_paid: 'No pagado',
  recent_invoices: 'Facturas recientes',
  recent_quotes: 'Cotizaciones recientes',
  customer_preview: 'Vista previa del cliente',
  sign_in_label: 'Ingresa tu correo electrónico y contraseña para iniciar sesión.',
  show: 'Mostrar',
  edit: 'Editar',
  download: 'Descargar',
  draft: 'Borrador',
  pending: 'Pendiente',
  sent: 'Enviado',
  declined: 'Rechazado',
  accepted: 'Aceptado',
  expired: 'Vencido',
  new_customer_this_month: 'Nuevo cliente este mes',
  active_customer: 'Cliente activo',
  overdue: 'Atrasado',
  partially: 'Parcialmente',
  paid: 'Pagado',
  sign_in: 'Iniciar sesión',
  log_in: 'Iniciar sesión',
  register_now: 'Regístrate ahora',
  remember_me: 'Recuérdame',
  forgot_password: 'Olvidé mi contraseña',
  forget_password: 'Olvidar contraseña',
  request_new_password: 'Solicitar nueva contraseña',
  password_reset_in_progress: 'Restablecimiento de contraseña en progreso',
  check_your_email_address_to_reset_your_password:
    'Revisa tu dirección de correo electrónico para restablecer tu contraseña',
  login: 'Iniciar sesión',
  reset_password: 'Restablecer contraseña',
  update_password: 'Actualizar contraseña',
  profile: 'Perfil',
  first_name: 'Nombre',
  last_name: 'Apellido',
  role: 'Rol',
  close: 'Cerrar',
  save: 'Guardar',
  photo: 'Foto',
  click_to_upload: 'Haz clic para subir',
  new_password: 'Nueva contraseña',
  confirm_password: 'Confirmar contraseña',
  general_settings: 'Configuración general',
  company_settings: 'Configuración de la empresa',
  company_logo: 'Logotipo de la empresa',
  currency_settings: 'Configuración de moneda',
  finance_settings: 'Configuración financiera',
  settings_list: 'Lista de configuración',
  add_new_settings: 'Agregar nueva configuración',
  update_your_app_configuration: 'Actualiza la configuración de tu aplicación',
  language: 'Idioma',
  date_format: 'Formato de fecha',
  update_your_company_informations: 'Actualiza la información de tu empresa',
  company_name: 'Nombre de la empresa',
  company_address: 'Dirección de la empresa',
  company_state: 'Estado de la empresa',
  company_country: 'País de la empresa',
  company_email: 'Correo electrónico de la empresa',
  company_phone: 'Teléfono de la empresa',
  company_cell: 'Celular de la empresa',
  company_website: 'Sitio web de la empresa',
  company_tax_number: 'Número fiscal de la empresa',
  company_vat_number: 'Número de IVA de la empresa',
  company_reg_number: 'Número de registro de la empresa',
  update_company_logo: 'Actualizar logotipo de la empresa',
  money_format_settings: 'Configuración del formato de dinero',
  default_currency: 'Moneda predeterminada',
  select_default_currency: 'Selecciona la moneda predeterminada',
  update_company_finance_settings: 'Actualiza la configuración financiera de la empresa',
  last_invoice_number: 'Último número de factura',
  last_quote_number: 'Último número de cotización',
  last_offer_number: 'Último número de oferta',
  last_payment_number: 'Último número de pago',
  client_list: 'Lista de clientes',
  customer_list: 'Lista de clientes',
  add_new_client: 'Agregar nuevo cliente',
  delete: 'Eliminar',
  type: 'Tipo',
  phone: 'Teléfono',
  refresh: 'Actualizar',
  are_you_sure_you_want_to_delete: '¿Estás seguro de que deseas eliminar?',
  delete_confirmation: 'Confirmación de eliminación',
  remove: 'Eliminar',
  cancel: 'Cancelar',
  select_date: 'Seleccionar fecha',
  add_new_person: 'Agregar nueva persona',
  add_new_company: 'Agregar nueva empresa',
  submit: 'Enviar',
  person: 'Persona',
  people_list: 'Lista de personas',
  firstname: 'Nombre',
  lastname: 'Apellido',
  company_list: 'Lista de empresas',
  contact: 'Contacto',
  website: 'Sitio web',
  lead_list: 'Lista de prospectos',
  add_new_lead: 'Agregar nuevo prospecto',
  source: 'Fuente',
  notes: 'Notas',
  new: 'Nuevo',
  in_negociation: 'En negociación',
  won: 'Ganado',
  loose: 'Perdido',
  canceled: 'Cancelado',
  assigned: 'Asignado',
  on_hold: 'En espera',
  waiting: 'Esperando',
  linkedin: 'Linkedin',
  social_media: 'Redes sociales',
  advertising: 'Publicidad',
  friend: 'Amigo',
  professionals_network: 'Red profesional',
  customer_referral: 'Referencia de cliente',
  sales: 'Ventas',
  other: 'Otro',
  add_new: 'Agregar nuevo',
  date: 'Fecha',
  sub_total: 'Subtotal',
  note: 'Nota',
  offer_list: 'Lista de ofertas',
  add_new_offer: 'Agregar nueva oferta',
  year: 'Año',
  expire_date: 'Fecha de vencimiento',
  item: 'Artículo',
  description: 'Descripción',
  quantity: 'Cantidad',
  price: 'Precio',
  add_new_tax: 'Agregar nuevo impuesto',
  select_tax_value: 'Selecciona el valor del impuesto',
  add_field: 'Agregar campo',
  error_404: 'Error 404',
  sorry_the_page_you_requested_does_not_exist: 'Lo sentimos, la página solicitada no existe',
  back: 'Atrás',
  download_pdf: 'Descargar PDF',
  send_by_email: 'Enviar por correo electrónico',
  convert_to_invoice: 'Convertir a factura',
  subtotal: 'Subtotal',
  address: 'Dirección',
  update: 'Actualizar',
  expired_date: 'Fecha de vencimiento',
  created_by: 'Creado por',
  invoice_list: 'Lista de facturas',
  add_new_invoice: 'Agregar nueva factura',
  record_payment: 'Registrar pago',
  tax_total: 'Total de impuestos',
  show_invoice: 'Mostrar factura',
  payment_status: 'Estado del pago',
  discount: 'Descuento',
  amount: 'Monto',
  reference: 'Referencia',
  add_payment_mode: 'Agregar modo de pago',
  quote_list: 'Lista de cotizaciones',
  add_new_quote: 'Agregar nueva cotización',
  payment_list: 'Lista de pagos',
  add_new_payment: 'Agregar nuevo pago',
  payment_information: 'Información de pago',
  total_paid: 'Total pagado',
  total_remaining: 'Total restante',
  product_list: 'Lista de productos',
  add_new_product: 'Agregar nuevo producto',
  ref: 'Ref',
  product_category_list: 'Lista de categorías de productos',
  add_new_product_category: 'Agregar nueva categoría de producto',
  color: 'Color',
  enabled: 'Habilitado',
  expense_list: 'Lista de gastos',
  add_new_expense: 'Agregar nuevo gasto',
  expense_category: 'Categoría de gasto',
  expense_category_list: 'Lista de categorías de gastos',
  add_new_expense_category: 'Agregar nueva categoría de gasto',
  admin_list: 'Lista de administradores',
  add_new_admin: 'Agregar nuevo administrador',
  admin_super_admin: 'Administrador Super Admin',
  staff_admin_crud: 'Administración de personal CRUD',
  staff_cru: 'Personal CRU',
  create_and_read_only: 'Crear y solo lectura',
  read_only: 'Solo lectura',
  currency_list: 'Lista de monedas',
  add_new_currency: 'Agregar nueva moneda',
  currency_name: 'Nombre de la moneda',
  currency_code: 'Código de la moneda',
  currency_symbol: 'Símbolo de la moneda',
  currency_position: 'Posición de la moneda',
  decimal_separator: 'Separador decimal',
  thousand_separator: 'Separador de miles',
  cent_precision: 'Precisión de centavos',
  zero_format: 'Formato de cero',
  default: 'Predeterminado',
  payment_mode_list: 'Lista de modos de pago',
  add_new_payment_mode: 'Agregar nuevo modo de pago',
  default_mode: 'Modo predeterminado',
  value: 'Valor',
  taxes_list: 'Lista de impuestos',
  do_you_need_help_on_customize_of_this_app: '¿Necesitas ayuda para personalizar esta aplicación?',
  contact_us: 'Contáctanos',
  customers: 'Clientes',
  peoples: 'Personas',
  companies: 'Empresas',
  leads: 'Prospectos',
  offer_leads: 'Ofertas de prospectos',
  invoices: 'Facturas',
  quotes: 'Cotizaciones',
  payments: 'Pagos',
  products: 'Productos',
  products_category: 'Categoría de productos',
  expenses: 'Gastos',
  currencies: 'Monedas',
  payments_mode: 'Modos de pago',
  account_owner: 'Propietario de la cuenta',
  create_only: 'Solo crear',
  enter_code: 'Ingresa el código',
  offers: 'Ofertas',
  proforma_invoices: 'Facturas proforma',
  search: 'Buscar',
  role: 'Rol',
  roles: 'Roles',
  add_new_role: 'Agregar nuevo rol',
  permissiontype: 'Tipo de permiso',
  actions: 'Acciones',
  add_new_employee: 'Agregar Nuevo Empleado',
  dateborn: 'Fecha de nacimiento',
  id: 'ID',
  employee_list: 'Lista de Empleados',
  city: 'Ciudad',
  clientstatus: 'Estado del cliente',
  business: 'Negocio',
  businesscontacts: 'Proveedores',
  attendance: "Asistencias",
  blood_type: "Tipo de Sangre",
  birth_date: "Fecha de Nacimiento",
  memberships: 'Membresías',
  memberships_list: "Lista de Membresias",
  add_new_membership: "Agregar Nueva Membresia",
  calendar: "Calendario",
  business_contacts_list: "Lista de Proveedores",
  add_new_business_contact: "Agregar Nuevo Proveedor",
  employees: "Empleados",
  access_card: "Tarjeta de Ingreso",
  postal_code: "Código Postal",
  allergies: "Alergias",
  weight: "Peso",
  height: "Altura",
  medical_conditions: "Condiciones Medicas",
  name_contact_emergency: "Nombre de Contacto de Emergencia",
  phone_contact_emergency: "Teléfono de Contacto de Emergencia",
  start_date: "Fecha de Inicio",
  end_date: "Fecha de Finalización",
  relationship_contact_emergency: "Parentesco de Contacto de Emergencia",
  suppliers: "Proveedores",
  auth_pages: 'Cuenta',
  gyms: "Gimnasios",
  dashboard_configurator: "Panel de Control",
  dashboard_options: "Opciones de Configuración",
  change_lenguage: "Idioma",
  change_colors: "Cambio de Color",
  gym_signup_link: "Enlace de Registro",
  qr_for_register: "QR para Registro",
  qr_for_attendance: "QR para Asistencia",
  businesscontacts: 'Contactos comerciales',
  quantity_attendances: 'Cantidad de asistencias',
  number_dni:"Número de Documento",
  dni_type:"Tipo de Documento",
  membership: 'Membresías',
  medical_conditions:"Condiciones Médicas",
  physiological_parameters:"Parámetros Fisiológicos",
  emergency_contact:"Contacto de Emergencia",
  subscription_info:"Datos de la Subscripción",
  title_message:"Por favor, completa los detalles requeridos",
  subscriptions: 'Suscripciones',
  attendances: 'Asistencias'
};

export default lang;